import store from '../../store';
import { FETCH_PAGES } from '@/store/actions/page.actions';

export const PagesLoaded = (to, from, next) => {
  const pagesLoaded = store.getters.pagesLoaded;

  if (!pagesLoaded) {
    return store.dispatch(FETCH_PAGES)
        .then(() => next())
        .catch(() => next({name: 'error'}))
  }

  return next();
};